import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
export default function BuiltOn20YearsOfFaithFamily() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="62328" id="practical-support-built-for-northern-realities" ref={ref} className={cn("bg-background text-foreground py-16 md:py-24 overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 xl:gap-20 items-center">
          <div className="relative group mx-auto lg:mx-0 w-full max-w-lg">
            <div className="absolute inset-0 border border-secondary/25 translate-x-4 translate-y-4 rounded-2xl -z-10 transition-transform duration-700 group-hover:translate-x-2 group-hover:translate-y-2" />

            <div className="relative overflow-hidden rounded-2xl shadow-xl bg-muted border border-border">
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none z-10" />

              <img src="https://stable-woodcock.10web.cloud/wp-content/uploads/2026/04/Lakeside-road-at-dawn-in-Ontario.png" alt="Northern Ontario landscape with water, trees, and shoreline" className="w-full h-full object-cover aspect-[4/5] transition-transform duration-700 group-hover:scale-105" loading="lazy" />
            </div>
          </div>

          <div className="space-y-7 text-center lg:text-left">
            <div className="space-y-4">
              <span className="inline-block text-secondary font-default font-bold tracking-widest uppercase text-sm">
                Built for Northern realities
              </span>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-500 leading-tight max-w-2xl mx-auto lg:mx-0">
                Practical support that fits
                <span className="text-secondary block mt-1">
                  real-world conditions
                </span>
              </h2>
            </div>

            <div className="space-y-5 text-base md:text-lg text-muted-foreground leading-relaxed font-default max-w-2xl mx-auto lg:mx-0">
              <p>
                RiverBend helps organizations make sense of complex financial and
                operational challenges through hands-on support, clear systems,
                and dependable follow-through. We work alongside leadership and
                staff in a way that is practical, respectful, and grounded in
                real-world Northern conditions.
              </p>

              <p>
                Our work extends beyond traditional accounting. We support
                governance, community development, audit readiness, financial
                recovery, project planning, and reporting systems that help
                clients build stronger operations, clearer information, and
                long-term capacity.
              </p>
            </div>

            <div className="pt-2 flex justify-center lg:justify-start">
              <Button asChild variant="outline" size="lg" className="h-12 px-8 rounded-md border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white font-default">
                <Link to="/about-riverbend">
                  About RiverBend
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}